<template>
  <div class="aboutPage">
    <div class="fill-height absolute" :style="{'background-image': `url(${MainBg})`}"></div>
    <transition mode="out-in">
      <div v-if="About && About._slug == $language.current" key="loaded" class="content px-8">
        <!-- <div class="hero-background" v-if="$vuetify.breakpoint.mdAndUp"><span v-for="i in 12" :key="i">About&nbsp;</span></div> -->
        <component
          v-for="(block, i) in About.content"
          :key="i"
          :is="repeaterComponents[block._repeaterType]"
          no-offset
          :data="block"
          :style="{'--appear-delay': `${500 + (i  * 100)}ms`}"
        />
        <div>
          <v-btn
            rel="noopener"
            aria-label="Vogue Website"
            data-cursor-target="center center"
            text
            class="social-btn"
            @click="$root.soundManager.playClick()"
            href="https://www.vogue.it"
            target="_blank"
          >
            Vogue.it
          </v-btn>
          <v-btn
            rel="noopener"
            aria-label="Instagram"
            data-cursor-target="center center"
            text
            class="social-btn"
            @click="$root.soundManager.playClick()"
            href="https://www.instagram.com/vogueitalia"
            target="_blank"
          >
            Ig
          </v-btn>
          <v-btn
            rel="noopener"
            aria-label="Facebook"
            data-cursor-target="center center"
            text
            class="social-btn"
            @click="$root.soundManager.playClick()"
            href="https://www.facebook.com/VogueItalia"
            target="_blank"
          >
            Fb
          </v-btn>
        </div>
      </div>
      <v-row v-else class="fill-height absolute" align="center" justify="center" key="loading">
        <v-col class="shrink"><LoadingSpinner /></v-col>
      </v-row>
    </transition>
  </div>
</template>

<script>
import MainBg from '@/assets/img/main-bg.jpg'
import GetAbout from '@/graphql/GetAbout.gql'
import LoadingSpinner from '@/atoms/LoadingSpinner'
import ContentParagraph from '@/atoms/ContentParagraph'
import ContentTitle from '@/atoms/ContentTitle'
import ContentLogoRow from '@/atoms/ContentLogoRow'
import ContentNameList from '@/atoms/ContentNameList'
import ContentCredits from '@/atoms/ContentCredits'

export default {
  name: 'AboutPage',
  components: {
    LoadingSpinner
  },
  apollo: {
    About: {
      query () {
        return GetAbout
      },
      variables () {
        return {
          slug: this.$language.current,
          status: 'PUBLISHED'
        }
      },
      result () {
        this.$root.$emit('scroll-to-saved-position')
      }
    }
  },
  data () {
    return {
      MainBg,
      repeaterComponents: {
        Paragraph: ContentParagraph,
        Title: ContentTitle,
        Credits: ContentCredits,
        'Name List': ContentNameList,
        'Logo Row': ContentLogoRow
      }
    }
  },
  // mounted () {
  //   this.$root.$emit('scroll-to-saved-position')
  // },
  metaInfo () {
    return {
      // about page browser title
      title: this.$root.siteSettings.aboutPageTitle,
      meta: [
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: `${this.$root.siteSettings.aboutPageTitle} | ${this.$root.siteSettings.siteTitle}` }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.hero-background {
  position: absolute;
  top: 15vw;
  left: 0;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  font-size: 30vw;
  opacity: 0.05;
  font-family: $heading-font-family;
  user-select: none;
  pointer-events: none;
  animation: hero-title-motion 20s linear forwards infinite;
}

.absolute {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  background-attachment: fixed;
  background-size: cover;
}

.content {
  margin-top: 150px;
  padding-bottom: 50px;
  text-align: center;
  @include breakpoint('md-and-up') {
    margin-top: 300px;
  }
  @include breakpoint('xl-only') {
    font-size: 1.25rem;
  }
}

::v-deep h3 {
  text-transform: uppercase;
  font-family: $body-font-family;
  font-size: 1em !important;
  color: map-get(map-get($material-light, 'text'), 'secondary');
}

.paragraph-block,
.name-list-block,
.logo-row-block {
  padding-bottom: 120px;

  @include breakpoint('md-and-down') {
    padding-bottom: 60px;
  }
}

.title-block ::v-deep .col {
  margin-top: 0 !important;
}

.paragraph-block,
.credits-block {
  max-width: 1100px;
  margin: 0 auto;
}

.name-list-block {
  max-width: 750px;
  margin: 0 auto;
}

</style>
